<template>
    <div :class="classNames">
        <!-- <sysUpdateInfo></sysUpdateInfo> -->
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm" label-position="top">
            <el-form-item label="选择提现账户" prop="account_id">
                <template slot="label">
                    <span>选择提现账户</span>
                    <div :class="classNames+ '_addCount'" @click="addAccount">
                        添加账户
                    </div>
                    <el-button type="primary" style="margin-left: 20px;" @click="refreshAccountList" size="mini">点击刷新</el-button>
                    <div style="float:right"><el-button type="primary" @click="goNewWithdrawal" size="mini" v-if="tax === 1 && staticPath === '/'">进入新版提现</el-button></div>
                </template>
                <account-list @needRefresh="refreshAccountList" v-model="ruleForm.account_id" @deleteAccount="deleteAccount" :data="bankList"></account-list>
            </el-form-item>
             <el-form-item label="请填写提现金额" prop="amount">
                <div :class="classNames+ '_item_con'">
                    <div :class="classNames+ '_item_con_top'">
                        <div :class="classNames+ '_item_con_tit'" style="align-self: flex-start;">
                            <p>可提现金额（元）{{surplus}}</p>
                            <span>（满10元可提现）</span>
                        </div>
                        <div v-if=" deposit_money && deposit_money!='0.00'" :class="classNames+ '_item_con_tit'" style="margin-left:30px;display: block;">
                            <div :class="classNames+ '_item_con_tit_guarantee'">
                                <p>保证金（元）{{ deposit_money }}</p>
                                <el-tooltip popper-class="tooltip-class" content="保证金：是从讲师可提现余额里暂时冻结的部分资金作为讲师在本平台的信誉金额，如讲师退出该平台时可向平台商务联系退还" placement="top" trigger="hover">
                                    <img class="question" src="http://img-dbzd.doubaozhidao.com/20220815/rAaEw2JCF5WcD7sTaxjMYShkmnARrmM21660554235278.png?x-oss-process=image/quality,q_80/format,png" alt=""/>
                                </el-tooltip>
                            </div>
                            <div :class="classNames+ '_item_con_tit_guaranteed'">
                                <span>(实缴: {{ is_deposited_money }})</span>
                                <span :class="classNames+ '_deposit_history_button'" @click="navigateDepositHistory">
                                    扣除记录
                                    <i class="el-icon-arrow-right"></i>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div :class="classNames+ '_item_con_money'">
                        <span>提现金额</span>
                        <div style="width:236px">
                            <el-input placeholder="请输入提现金额" v-model="ruleForm.amount" @input="handlePrice('amount')"/>
                        </div>
                    </div> 
                </div>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submit('ruleForm')" class="btn-121-40">提现</el-button>
            </el-form-item>
        </el-form>
        <add-account v-model="visible" @submitSucess="submitSucess" ref="addAccount" :key="addAccountFlag"></add-account>
        <withdrawal-res-dialog v-model="withdrawalResDialogFlag" :dataObj="dataAccountObj" @sure="sure">
        </withdrawal-res-dialog>
        <!-- <div class="system-maintenance-mask" v-if="showSysMaintenanceMask">
            系统升级中，暂不可提现
        </div> -->
    </div>
</template>
<script>
import { mapState,mapActions } from 'vuex'
import AccountList from './accountList.vue'
import AddAccount from './addAccount.vue'
import withdrawalResDialog from './withdrawalResDialog.vue'
import sysUpdateInfo from './components/sysUpdateInfo.vue'
import { throttle } from 'lodash-unified'
import { sendPost } from '@/api/http.js';
export default {
    name: 'WithdrawalManage',
    data() {
        const amountValidator = (rule, value, callback) => {
            if(value == '') {
                callback(new Error('请输入提现金额'))
            } else {
                if(value * 100 > this.surplus * 100) {
                    callback(new Error('可提现金额不足'))
                } else if(this.surplus * 100 < 1000) {
                    callback(new Error('可提现金额不满10元'))
                } else if(this.surplus == 0) {
                    callback(new Error('提现金额不能为0元'))
                }
                callback()
            }
        }
        return {
            classNames: 'changeAccount',
            ruleForm: {
                amount: '',
                account_id: ''
            },
            rules: {
                account_id: [
                    { required: true, message: '请选择提现账户', trigger: 'change' }
                ],
                amount: [
                    { required: true, validator: amountValidator, trigger: 'change' }
                ]
            },
            visible: false,
            withdrawalResDialogFlag: false,
            surplus: '',
            deposit_money: '', //保证金
            is_deposited_money: '', //实缴保证金
            bankList: [],
            dataAccountObj: {
                amount: '',
                account: ''
            },
            addAccountFlag: false
        }
    },
    components: {
        'account-list': AccountList,
        'add-account': AddAccount,
        'withdrawal-res-dialog': withdrawalResDialog,
        sysUpdateInfo
    },
    created() {
        this.getSurplusFun()
        this.getAccountFun()
    },
    methods: {
        ...mapActions('withdrawal', ['getSurplus', 'getAccount', 'removeAccount', 'cashApply', 'oldBankToFuyouAPI']),
        addAccount() {
            // if(!this.noWidthdraw()) return // 升级维护
            this.visible = true
        },
        // 刷新账户列表
        refreshAccountList(){
            this.getAccountFun()
        },
        // 提现暂停
        noWidthdraw(){
            const whiteList = [25, 408, 2564, 1127] // 白名单用户
            if(whiteList.includes(parseInt(this.userInfo.id))){
                return true
            }
            const content = `<b>由于平台财务系统升级，所有豆包账户模式今日（2024年6月28日）将暂时无法进行提现操作，预计今日下午5点前恢复正常，请您见谅。</b><br/>
本次升级后：<br/>
1、提现无限额；<br/>
2、豆包账户将不在支持支付宝提现方式；<br/>
3、豆包账户将只支持银行卡提现方式；<br/>
4、新添加银行卡账户需进行人脸验证；<br/>
5、原已绑定银行卡账户需重新进行人脸验证；<br/>
6、同一个实名身份最多可添加3张银行卡。`
            this.$alert(content, '提示', {
                dangerouslyUseHTMLString: true
            });
            return false
        },
        submit:throttle(async function(formName) {
            console.log('submitdsadasdad',formName);
            const response = await sendPost('/user/user/wallet_freezes/verify_account_freeze');
            // console.log('店铺列表店铺列表店铺列表',response);
            // 前端跳转路径：
            // app_user_id：user_id
            // application:项目: 1=抖推猫  2=创作猫  3=老抖推猫  4=趣测趣玩  5=抖推猫图库  6=推图社
            //                 7=左佣  8=幻颜秀秀App 9=推文社 10=千川短剧  11=豆包知道  12=柚趣
            // 测试地址：http://dtmplatformh5.fat.doutuiweb.net/#/pages/index/index
            // 正式地址：https://dtmplatformh5.doutuimao.net/#/pages/index/index
            if(response.status == 2){
                this.$message.error('您的账户已被冻结，请先解冻');
                let baseURL= ''
                if(process.env.VUE_APP_GRALIC === 'development') {
                    baseURL = 'http://dtmplatformh5.fat.doutuiweb.net/#'
                } else if(process.env.VUE_APP_GRALIC === 'test') {
                    baseURL = 'http://dtmplatformh5.fat.doutuiweb.net/#'
                } else {
                    baseURL = 'https://dtmplatformh5.doutuimao.net/#'
                }
                setTimeout(()=>{
                    window.open(baseURL+ `/pages/index/index?app_user_id=${response.app_user_id}&application=11`)
                },300)
            }else{
                console.log('验证通过，可以提现',this.$refs[formName]);
                
                // if(!this.noWidthdraw()) return // 升级维护
                this.$refs[formName].validate(async (valid) => {
                    console.log(valid,'validvalid');
                    
                    // if (valid) {
                        try{
                            console.log('提交提现');
                            
                            await this.cashApply(this.ruleForm)
                            let obj = this.bankList.find(item => item.id == this.ruleForm.account_id)
                            this.dataAccountObj = obj? {amount: this.ruleForm.amount, ...obj} : {}
                            this.withdrawalResDialogFlag = true
                            this.getSurplusFun()
                            this.ruleForm.amount = ''
                        }catch(err){
                            console.log('err:',err)
                            if(err.code == '-499'){
                                let that = this
                                this.$alert('银行卡账户需进行人脸验证', '提示', {
                                    confirmButtonText: '点击获取验证',
                                    callback: action => {
                                        that.oldBankToFuyouAPI({
                                            account_id: that.ruleForm.account_id
                                        })
                                    }
                                });
                            }else{
                                this.$message.error(err.message || '失败')
                            }
                        }
                    // }
                })
            }
            
            
        },1000),
        submitSucess() {
            this.getAccountFun()
            this.addAccountFlag = !this.addAccountFlag
        },
        async getSurplusFun() {
            let res = await this.getSurplus()
            this.surplus = res.surplus
            this.deposit_money = res.deposit_money
            this.is_deposited_money = res.is_deposited_money
        },
        async getAccountFun() {
            let res = await this.getAccount()
            this.bankList = res
            console.log(this.bankList, '银行卡')
            this.getDefaltId(this.bankList)
        },
        getDefaltId(list) {
            let data = list.filter(item => item.status == 2 && item.account_type!=1)
            if(data.length == 0) {
                this.ruleForm.account_id = ''
            } else {
                this.ruleForm.account_id = data[0].id
            }
        },
        handlePrice(type) {
            this.ruleForm[type] = this.ruleForm[type].replace(/[^0-9.]/g, '')
            if (this.ruleForm[type].indexOf('.') > 0) {
                this.ruleForm[type] = this.ruleForm[type].slice(0, this.ruleForm[type].indexOf('.') + 3)
            }
        },
        deleteAccount(item) {
            this.$confirm(`是否删除账户${item.account}`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(async () => {
                await this.removeAccount({account_id: item.id})
                this.bankList = this.bankList.filter(items => items.id != item.id)
                this.ruleForm.account_id == item.id ? this.getDefaltId(this.bankList): ''
                this.$message({
                    type: 'success',
                    message: '删除成功!',
                    duration: 3000
                })
            })
        },
        sure() {
            this.$router.push(this.staticPath + 'withdrawalRecord')
        },
        goNewWithdrawal() {
            this.$emit('change', 1)
        },
        handleBreadCrumb(path, name, id, index = 2) {
            let breadCrumbList = this.breadCrumbList.slice(0, index)
            breadCrumbList[index] = {
                title: name,
                path: id ? path + '/' + id : path
            }
            localStorage.setItem('breadCrumbList', JSON.stringify(breadCrumbList))
            this.$router.push({
                path: id ? path + '/' + id : path,
            })
            breadCrumbList[index] = {
                title: name,
                path: this.$route.fullPath
            }
        },
        navigateDepositHistory() {
            this.handleBreadCrumb(this.staticPath + 'depositHistory', '扣除记录', 0, 2)
        },
    },
    computed: {
        ...mapState('dataCenter', ['tax']),
        ...mapState(['breadCrumbList']),
        ...mapState('login', ['userInfo']),
        // showSysMaintenanceMask(){ // 显示系统维护遮罩
        //     let whiteList = [222,111] // 白名单用户没有遮罩
        //     if(whiteList.includes(parseInt(this.userInfo.id))){
        //         return false
        //     }else{
        //         return true
        //     }
        // }
    }
}
</script>
<style lang="less">
.verification_wrap {
    .el-dialog__body {
        padding: 10px 20px;
        min-height: 100px;
        max-height: 200px;
    }
    .verification_con {
        width: 100%;
        .verification_item {
            display: flex;
            width: 100%;
            align-items: center;
            line-height: 40px;
            .verification_label {
                width: 100px;
                text-align: right;
                margin-right: 12px;
            }
            .sendBox {
                width: 360px;
                height: 40px;
                background: #fff;
                border-radius: 4px;
                border: 1px solid #c7cada;
                display: flex;
                justify-content: space-between;
                align-items: center;
                position: relative;
                .el-input__inner {
                    border: none;
                }
                .sendBox_btn {
                    white-space: nowrap;
                    color: #4e70f2;
                    font-size: 12px;
                    width: 108px;
                    text-align: center;
                }
                .sendBox_line {
                    width: 1px;
                    height: 25px;
                    background: #dcdfe6;
                }
            }
        }
    }
}
</style>
<style lang="less" scoped>
@classNames: changeAccount;
.@{classNames} {
    position: relative;
    /deep/.el-form {
        .el-form-item {
            .el-form-item__label {
                width: 100%;
            }
        }
    }
    .@{classNames}_addCount {
        width: 95px;
        height: 25px;
        line-height: 25px;
        text-align: center;
        background: #FFFFFF;
        border-radius: 4px;
        border: 1px solid #1989FA;
        color: #1989FA;
        display: inline-block;
        margin-left: 30px;
        cursor: pointer;
    }
    .@{classNames}_item_con {
        width: 660px;
        // height: 140px;
        background: #FFFFFF;
        box-shadow: 0px 8px 24px 0px rgba(18, 38, 63, 0.03);
        border-radius: 8px;
        border: 1px solid #4E70F2;
        padding: 32px 0 32px 32px;
        box-sizing: border-box;
        .@{classNames}_item_con_top {
            display: flex;
            align-items: center;
            .@{classNames}_item_con_tit {
                display: flex;
                align-items: center;
                font-size: 16px;
                line-height: 16px;
                p {
                    color: #000000;
                    margin-right: 12px;
                }
                span {
                    color: #999999;
                }
                .@{classNames}_item_con_tit_guarantee{
                    display: flex;
                    align-items: center;
                    .question{
                        cursor: pointer;
                        width: 17px;
                        height: 17px;
                    }
                }
                .@{classNames}_item_con_tit_guaranteed{
                    margin-top: 6px;
                    color: #999999;
                }
                .@{classNames}_deposit_history_button {
                    margin-left: 12px;
                    display: inline-flex;
                    align-items: center;
                    color: #4E70F2;
                    cursor: pointer;
                    i {
                        margin-left: 2px;
                        font-size: 14px;
                        transform: translateY(0.5px);
                    }
                }
            }
        }
        .@{classNames}_item_con_money {
            display: flex;
            align-items: center;
            margin-top: 24px;
            >span {
                white-space: nowrap;
                margin-right: 18px;
            }
        }
    }
    // .system-maintenance-mask{
    //     background: rgba(0, 0, 0, .8);
    //     position: absolute;
    //     left: -20px;
    //     top: -20px;
    //     width: 110%;
    //     height: 108.5%;
    //     color: #fff;
    //     font-size: 30px;
    //     display: flex;
    //     align-items: center;
    //     justify-content: center;
    // }
}
</style>